// Module
var code = "<div class=\"batch-view\"> <iframe class=\"batch\" ng-src=\"{{ $ctrl.src }}\"></iframe> <div ng-if=\"$ctrl.isLoading\" class=\"loader\"> <div>Chargement...</div> </div> </div> ";
// Exports
export default code;